import { render, staticRenderFns } from "./ColorPlate.vue?vue&type=template&id=9aca76ee&"
import script from "./ColorPlate.vue?vue&type=script&lang=js&"
export * from "./ColorPlate.vue?vue&type=script&lang=js&"
import style0 from "./ColorPlate.vue?vue&type=style&index=0&id=9aca76ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports